import React, { Component } from 'react';
import Icon from './ui/AppIcon';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;

      return (
        <div className="min-h-[50vh] flex flex-col items-center justify-center px-4 py-16 text-center bg-[#f5f5f5]">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
            <Icon name="ExclamationTriangleIcon" size={32} className="text-[#e8471e]" />
          </div>
          <h1 className="text-xl font-bold text-[#003087] mb-2">Something went wrong</h1>
          <p className="text-sm text-gray-600 mb-6 max-w-sm">
            {this.state.error?.message || 'An unexpected error occurred. Please try again.'}
          </p>
          <button
            type="button"
            onClick={this.handleRetry}
            className="min-h-[44px] px-5 py-2.5 rounded-lg bg-[#003087] text-white text-sm font-semibold hover:bg-[#002466] transition-colors"
          >
            Try again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
